import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ButtonColorTestPage() {
  return <div className="w-full min-h-screen bg-white py-12 px-6" data-id="element-721">
      <div className="max-w-4xl mx-auto" data-id="element-722">
        {/* Back button */}
        <div className="mb-8" data-id="element-723">
          <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-724">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-725" />
            <span data-id="element-726">Go Back</span>
          </Link>
        </div>
        {/* Main content */}
        <div className="bg-gray-50 rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-727">
          <h1 className="text-3xl font-bold text-gray-900 mb-10 text-center" data-id="element-728">
            CTA Button Color Options
          </h1>
          <div className="space-y-12" data-id="element-729">
            {/* Sunset Coral */}
            <div className="space-y-6" data-id="element-730">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-731">
                Sunset Coral (#f46b5b)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-732">
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-733">
                  <span data-id="element-734">Primary Button</span>
                </button>
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-735">
                  <span data-id="element-736">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-737" />
                </button>
                <button className="border-2 border-[#f46b5b] text-[#f46b5b] px-6 py-3 rounded-md font-medium hover:bg-[#f46b5b] hover:text-white transition-colors" data-id="element-738">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Golden Amber */}
            <div className="space-y-6" data-id="element-739">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-740">
                Golden Amber (#f6b736)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-741">
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-742">
                  <span data-id="element-743">Primary Button</span>
                </button>
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-744">
                  <span data-id="element-745">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-746" />
                </button>
                <button className="border-2 border-[#f6b736] text-[#f6b736] px-6 py-3 rounded-md font-medium hover:bg-[#f6b736] hover:text-white transition-colors" data-id="element-747">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Bright Sky Blue */}
            <div className="space-y-6" data-id="element-748">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-749">
                Bright Sky Blue (#4dc4f7)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-750">
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-751">
                  <span data-id="element-752">Primary Button</span>
                </button>
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-753">
                  <span data-id="element-754">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-755" />
                </button>
                <button className="border-2 border-[#4dc4f7] text-[#4dc4f7] px-6 py-3 rounded-md font-medium hover:bg-[#4dc4f7] hover:text-white transition-colors" data-id="element-756">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Comparison Section */}
            <div className="pt-10 border-t border-gray-200" data-id="element-757">
              <h2 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-758">
                Side-by-Side Comparison
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-759">
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-760">
                  <span data-id="element-761">Sunset Coral</span>
                  <ArrowRightIcon size={18} data-id="element-762" />
                </button>
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-763">
                  <span data-id="element-764">Golden Amber</span>
                  <ArrowRightIcon size={18} data-id="element-765" />
                </button>
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-766">
                  <span data-id="element-767">Bright Sky Blue</span>
                  <ArrowRightIcon size={18} data-id="element-768" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}